import React, { useState } from 'react';
import CustomButton from './CustomButton';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSexl_xqoeNH3Cai600ze476RAz4yZoWQIx-HZSsSaxoZRrqHA/formResponse';
    
    // Create form data with correct entry IDs from the form source
    const formBody = new FormData();
    formBody.append('entry.924507045', formData.name);
    formBody.append('entry.1777562902', formData.email);
    formBody.append('entry.944050344', formData.company);
    formBody.append('entry.446859139', formData.message);

    try {
      // Submit the form using fetch with no-cors mode
      await fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: formBody,
      });

      // Clear form and show success message
      setFormData({
        name: '',
        email: '',
        company: '',
        message: ''
      });
      setSubmitStatus('success');
    } catch (error) {
      console.error('Submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-32">
      <div className="max-w-2xl mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-bold text-[#003B5C] text-center mb-8">
          Contact Us
        </h1>
        <p className="text-center text-gray-700 mb-12">
        We'd love to learn from you how we can work together. Fill out the form below and we'll get back to you shortly.
        </p>

        <form onSubmit={handleSubmit} className="bg-white rounded-tr-[40px] rounded-bl-[40px] shadow-lg p-8">
          <div className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                Name *
              </label>
              <input
                type="text"
                name="name"
                id="name"
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8b123b] focus:border-transparent"
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email *
              </label>
              <input
                type="email"
                name="email"
                id="email"
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8b123b] focus:border-transparent"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1">
                Company *
              </label>
              <input
                type="text"
                name="company"
                id="company"
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8b123b] focus:border-transparent"
                value={formData.company}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                Message *
              </label>
              <textarea
                name="message"
                id="message"
                rows="4"
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8b123b] focus:border-transparent"
                value={formData.message}
                onChange={handleChange}
              />
            </div>

            <div className="flex flex-col items-center gap-4">
              <CustomButton 
                type="submit" 
                className={isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </CustomButton>
              
              {submitStatus === 'success' && (
                <p className="text-green-600 font-medium">Thank you for your message! We'll get back to you soon.</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-600 font-medium">There was an error sending your message. Please try again.</p>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;